import { ExtendedSessionCustomer } from '@cld/session-service';
import { MARKETPLACE_PAGE_URL, SETTINGS_PAGE_URL } from '../../ApplicationWrapper.const';

export const getSettingsHref = (currentCustomer?: ExtendedSessionCustomer) => {
  const id = currentCustomer ? `${currentCustomer.externalIdForUrl}` : '';
  return `${SETTINGS_PAGE_URL}${id}`;
};

export const getMarketplaceHref = (currentCustomer?: ExtendedSessionCustomer) => {
  const id = currentCustomer ? `${currentCustomer.externalIdForUrl}` : '';
  return `/pm${id}${MARKETPLACE_PAGE_URL}`;
};
